/**
 * Purpose: Shared overlay wrapper for blocking grid, modal, and panel loading.
 * Why: Prevents each screen from rebuilding its own absolute overlay and keeps
 * loading transitions visually consistent.
 */
import { Component, Input } from '@angular/core';

type LoadingOverlayTone = 'light' | 'soft' | 'dark';
type LoadingOverlaySize = 'sm' | 'md' | 'lg';

@Component({
    selector: 'cwr-loading-overlay',
    templateUrl: './loading-overlay.component.html',
    styleUrls: ['./loading-overlay.component.scss'],
})
export class LoadingOverlayComponent {
    @Input() active = false;
    @Input() message = 'Loading...';
    @Input() size: LoadingOverlaySize = 'md';
    @Input() tone: LoadingOverlayTone = 'soft';

    get overlayClasses(): string[] {
        return ['loading-overlay', `loading-overlay--${this.tone}`];
    }
}
